import BoostButtom from "./BoostButton";

export default BoostButtom;



// WEBPACK FOOTER //
// ./src/shared/components/NavBar/BoostButton/index.js